import { Box, Typography } from "@mui/material";

export default function AgentIntegrations() {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5">Intégrations</Typography>
      <Typography color="text.secondary">
        Code d’intégration et options multi-canaux.
      </Typography>
    </Box>
  );
}
